/**
 * Returns the full icon class string for FlatIcon library.
 * If the icon already starts with 'fi-', returns it as is.
 * Otherwise, adds the 'fi-rr-' prefix (regular style).
 *
 * @param icon - The icon name or full class (e.g., 'search' or 'fi-br-search')
 * @returns The complete icon class string (e.g., 'fi-rr-search' or 'fi-br-search')
 *
 * @example
 * getIconClass('search') // returns 'fi-rr-search'
 * getIconClass('fi-br-search') // returns 'fi-br-search'
 * getIconClass('fi-ss-user') // returns 'fi-ss-user'
 */
export function getIconClass(icon: string): string {
    if (!icon) return '';
    return icon.startsWith('fi-') ? icon : `fi-rr-${icon}`;
}
